import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import env from './config/index'
import { post, get } from 'network/db'
import { Toast, Dialog, Overlay, Stepper, Loading } from 'vant'
import * as filters from '@/utils/filters'


import 'vant/lib/dialog/style'
import 'vant/lib/toast/style'
import 'vant/lib/overlay/style'
import 'vant/lib/field/style'
// import 'vant/lib/cell/style'
// import 'vant/lib/cell-group/style'
import 'vant/lib/stepper/style'

import 'assets/style/normalize.min.css'
import 'assets/style/common.css'


Vue.prototype.$store = store
Vue.prototype.post = post
Vue.prototype.get = get
Vue.prototype.$env = env

Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.use(Overlay)
Vue.use(Stepper)
Vue.use(Loading)
Vue.use(Dialog)

// Test
// Vue.use(Field)
// Vue.use(Cell)
// Vue.use(CellGroup)


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
